// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5ce5f54","453":"3108daa4","732":"0db58e5a","977":"55e6f5cb"}[chunkId] + ".chunk.js";
};